import React, { ReactElement } from "react";
import { Button, Card, Statistic } from "antd";
import { HistoryOutlined } from "@ant-design/icons";
import { ActionsContainer, Container, IconContainer } from "./styles.js";

interface IStatProps {
  title: string;
  icon: ReactElement;
  iconColor?: string;
  value: string;
  noStyleIcon?: boolean;
  suffix?: string;
  prefix?: string;
  loading?: boolean;
  className?: string;
  noFormat?: boolean;
  editComponent?: ReactElement;
  valueHistoryComponent?: ReactElement;
}

const Stat: React.FC<IStatProps> = ({
  className,
  icon,
  noStyleIcon,
  iconColor,
  title,
  value,
  prefix,
  suffix,
  loading,
  noFormat = false,
  editComponent,
  valueHistoryComponent,
}) => {
  return (
    <Card
      className={className}
      style={{ height: "100%" }}
      bodyStyle={{ padding: "24px 0" }}
    >
      {icon ? (
        <Container>
          <IconContainer>
            {React.cloneElement(
              icon,
              !noStyleIcon
                ? {
                    style: {
                      ...icon.props.style,
                      color: iconColor ?? "var(--dark-orange)",
                      fontSize: 20,
                    },
                  }
                : {}
            )}
          </IconContainer>
          <Statistic
            valueStyle={
              {
                // fontSize: 24,
                // textOverflow: "ellipsis",
                // overflow: "hidden",
              }
            }
            style={{
              width: "calc(100% - 112px)",
            }}
            title={title}
            value={value}
            suffix={suffix}
            prefix={prefix}
            loading={loading}
            formatter={noFormat ? (_value) => _value : undefined}
          />
          <ActionsContainer>
            {editComponent && React.cloneElement(editComponent, {})}
            {valueHistoryComponent &&
              React.cloneElement(valueHistoryComponent, {})}
          </ActionsContainer>
        </Container>
      ) : (
        <Statistic valueStyle={{ fontSize: 20 }} title={title} value={value} />
      )}
    </Card>
  );
};

export default Stat;
